import styled from "@emotion/styled";

export const StyleShippingInfoContainer = styled.div`
  border-radius: 14px;
  padding: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 6px -4px black;
  display: flex;
  flex-direction: column;
  row-gap: 26px;
`;

export const StatusContainer = styled.div`
  border: 1px solid #cccccc;
  width: auto;
  height: 40px;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px;
`;

export const StatusLabel = styled.div`
  font-size: 14px;
`;

export const StatusValueContainer = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;

export const StatusValue = styled.span<{ $isPaid: boolean }>`
  color: ${({ $isPaid }) => ($isPaid ? "#4CAF50" : "#F44336")};
  font-weight: 500;
  font-size: 14px;
`;

export const StatusIcon = styled.img``;
export const SectionLabel = styled.p`
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
`;

export const StatusToggle = styled.img`
  width: 40px;
  height: 24px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.8;
  }
`;

export const TrackContainer = styled.div`
  background-color: #f9fafc;
  padding: 10px;
  display: flex;
  gap: 10px;
  align-items: center;
  border-radius: 5px;
`;

export const TruckIcon = styled.img`
  width: 24px;
  height: 24px;
`;

export const TrackInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StatusText = styled.p`
  font-weight: 600;
  margin: 0;
  color: #333;
`;

export const TrackIdText = styled.p`
  font-size: 14px;
  margin: 4px 0 0 0;
  color: #666;
`;
